import styled, { css } from 'styled-components';

import { Markdown } from '../EveryActionPetitionForm.styles';

import { Truncate, Button as TruncateButton } from '+/components/Truncate/Truncate.styles';

export const IssueText = styled.div`
  ${Truncate} {
    p {
      margin-bottom: 1rem;

      @media (min-width: ${props => props.theme.breakpoints.lg}) {
        margin-bottom: 1.875rem;
      }
    }

    p:last-child {
      margin-bottom: 2.5rem;

      @media (min-width: ${props => props.theme.breakpoints.lg}) {
        margin-bottom: 3.5rem;
      }
    }
  }

  ${Markdown} {
    overflow: hidden;
  }

  button:not(${TruncateButton}) {
    background: var(--color-theme-accent);
    color: var(--color-theme-inverse);
  }
`;

export const PetitionCTA = styled.div<{ isShown: boolean }>`
  display: flex;
  justify-content: center;
  background: rgba(29, 37, 44, 0.75);
  padding: 1.5rem;
  transition: transform 0.6s ease-in-out, opacity 0.6s;

  > button {
    width: 100%;
    max-width: 23rem;
  }

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    display: none;
  }

  ${props =>
    props.isShown
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 0;
          transform: translateY(100%);
        `}
`;
